import { RouteConfig } from '@abaco/web-common/src/app';

export type BreadCrumb = { text: string; link?: string };

function breadCrumb(params: { [key: string]: string }, isSingleSubject = true): BreadCrumb[] {
    const ret: BreadCrumb[] = [];
    if (!isSingleSubject) {
        ret.push({
            text: "subject-list",
            link: "/"
        });
    }
    ret.push({
        text: "contracts-list",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts`
    });

    ret.push({
        text: "pcr",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/application/${encodeURIComponent(params.applicationId)}/pcr`
    });
    return ret;
}

const children: RouteConfig[] = [
    {
        name: "pcr-home",
        path: "/",
        component: () => import("./components/PCR/PCRHome.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-financial-overview",
        path: "financial-overview",
        component: () => import("./components/PCR/PCRFinancialOverview.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-financial-overview-m6-p1",
        path: "financial-overview-m6-p1",
        component: () => import("./components/PCR/PCRFinancialOverviewM6P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-project-implementation",
        path: "project-implementation",
        component: () => import("./components/PCR/PCRProjectImplementation.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-disclaimer",
        path: "disclaimer",
        component: () => import("./components/PCR/PCRDisclaimer.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-best-practices",
        path: "best-practices",
        component: () => import("./components/PCR/PCRBestPractices.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-key-indicators-m4-p1",
        path: "key-indicators-m4-p1",
        component: () => import("./components/PCR/PCRKeyIndicatorsM4P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-key-indicators-m4-p3-roads",
        path: "key-indicators-m4-p3-roads",
        component: () => import("./components/PCR/PCRKeyIndicatorsM4P3Roads.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-key-indicators-m4-p3-water",
        path: "key-indicators-m4-p3-water",
        component: () => import("./components/PCR/PCRKeyIndicatorsM4P3Water.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-key-indicators-m4-p4",
        path: "key-indicators-m4-p4",
        component: () => import("./components/PCR/PCRKeyIndicatorsM4P4.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "pcr-key-indicators-m6-p1",
        path: "key-indicators-m6-p1",
        component: () => import("./components/PCR/PCRKeyIndicatorsM6P1.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
];

const routes: RouteConfig[] = [
    {
        path: "/subject/:subjectId/contracts/:contractId/application/:applicationId/pcr",
        component: () => import("./components/PCR/PCR.vue"),
        props: true,
        meta: {
            breadCrumb
        },
        children
    },
];

export default routes;
